import React, { useEffect } from 'react'
import { Container, Row } from 'react-bootstrap'
import Wrapper from '../../homeWrapper/Wrapper'
import './style.scss'
import HomeMainTitle from '../../homeTitle/HomeMainTitle'
import { fetchSaloons } from '../../../redux/action/saloons/saloons';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import MainLoading from '../../../utils/MainLoading'
import { Helmet } from 'react-helmet'
import { fetchAllAds } from '../../../redux/action/ads/getAds'
import default_image_url from '../../../redux/api/API'
import { useTranslation } from 'react-i18next'

const Saloons = () => {
    const saloons = useSelector(state => state.saloons)
    const dispatch = useDispatch()
    const all_ads = useSelector(state => state.all_ads)
    const {t} = useTranslation();

    useEffect(() => {
        if(!saloons.saloons.length) {
            dispatch(fetchSaloons())
        }
        if(!all_ads.all_ads.length) {
            dispatch(fetchAllAds())
        }
    }, [])

    return (
        <Wrapper>
            <Helmet>
                <title>سالن‌ها - نمایشگاه مجازی</title>
            </Helmet>
            <div className='saloons_page-wrapper '>
                <Container>
                    <HomeMainTitle>{t("Classification of industrial units")}</HomeMainTitle>
                    <Row>
                        <div className={all_ads.all_ads.length && all_ads.all_ads.filter(item => item.location === 'saloons') ? 'col-lg-9' : 'col-lg-12'}>
                            <div className=' animate__animated animate__fadeInDown'>
                                {saloons.loading ? 
                                    <MainLoading />
                                :
                                    saloons.saloons.length ?
                                        <Row className='saloons_page_items'>
                                            {saloons.saloons.map(saloon => (
                                                <div className='col-md-4 saloon_item' key={saloon.id} id={saloon.id}>
                                                    <Link to={`/saloon/${saloon.id}`}>
                                                        <h1> {saloon.name} </h1>
                                                        <h6>{saloon.users_count} {t("company")}</h6> 
                                                    </Link>  
                                                </div>
                                            )) }
                                        </Row>
                                    : 
                                        <div className='d-flex flex-column align-items-center'>
                                            <h5 className='text-center mt-5'>{t("A hall has not been built yet, register in the virtual exhibition via the following link")}</h5>
                                            <Link to="/register" className='btn purple-btn px-5 mt-4'>{t("register")}</Link>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className='col-lg-3 ad-container mt-5'>
                            {all_ads.all_ads.filter(item => item.location === 'saloons' & item.position === 'top').map(ad => (
                                <a key={ad.id} href={`//${ad.url}`} target='_blank' rel="nofollow" className='full-size-ad-container'>
                                    <img src={default_image_url+ad.path} alt={ad.url} />
                                </a>
                            ))}
                            {all_ads.all_ads.filter(item => item.location === 'saloons' & item.position === 'bottom').map(ad => (
                                <a key={ad.id} href={`//${ad.url}`} target='_blank' rel="nofollow" className='full-size-ad-container'>
                                    <img src={default_image_url+ad.path} alt={ad.url} />
                                </a>
                            ))}
                        </div>
                    </Row>
                </Container>
            </div>
        </Wrapper>
    )
}

export default Saloons
